module.exports.drawSilkscreenOfFootprintDescriptionTo2D = require("./renderDescription/drawSilkscreenOfFootprintDescriptionTo2D.js");
module.exports.drawSymbolDescriptionTo2D    = require("./renderDescription/drawSymbolDescriptionTo2D");

module.exports.drawHoleDataTo2D             = require("./renderData/drawHoleDataTo2D.js");
module.exports.drawShapeOfPadDataTo2D       = require("./renderData/drawShapeOfPadDataTo2D.js");
module.exports.drawHoleOfPadDataTo2D        = require("./renderData/drawHoleOfPadDataTo2D.js");
module.exports.drawSymbolTerminalDataTo2D   = require("./renderData/drawSymbolTerminalDataTo2D");

module.exports.colors                    = require("./colors/colors.js");

module.exports.DrillToolController  = require("./extensions/drillTool/drillToolController.js");
module.exports.HoleViewerController = require("./extensions/holeViewer/holeViewerController.js");

module.exports.PropertyToolController                   = require("./extensions/propertyTool/propertyToolController.js");
module.exports.PropertyToolStateMachine                 = require("./extensions/propertyTool/propertyToolStateMachine.js");

module.exports.PropertyViewerController                 = require("./extensions/propertyViewer/propertyViewerController.js");
module.exports.PropertyInteractionModel                 = require("./extensions/propertyViewer/propertyInteractionModel.js");
module.exports.PropertyInteractionView                 = require("./extensions/propertyViewer/propertyInteractionView.js");

module.exports.EnvironmentTesterController             = require("./extensions/environmentTester/environmentTesterController.js");
module.exports.LoadingWatchdogController             = require("./extensions/loadingWatchdog/loadingWatchdogController.js");

require('./config')